import React, { useEffect, useState, useContext } from "react";
import { TextField, Button, MenuItem, Typography, Box } from "@mui/material";
import CommonAccordion from "../../custom-components/CommonAccordion";
import { ReactComponent as GenerateButton } from "../../../images/generateButton.svg";
import SaveAltRoundedIcon from "@mui/icons-material/SaveAltRounded";
import { useLocation, useNavigate } from "react-router-dom";
import { LoadingModalContext } from "../../main-pages/ServicePage";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import { IconButton, InputAdornment } from "@mui/material";

const TestEnvironmentForm = (props) => {
  const [formData, setFormData] = useState({
    url: "",
    username: "",
    password: "",
    os: "Windows",
    browser: "Chrome",
    url: "",
    username: "",
    password: "",
    os: "Windows",
    browser: "Chrome",
  });

  const osOptions = ["Ubuntu", "Windows", "MacOS"];
  const [selectedBranch, setSelectedBranch] = useState('');
  const [urlError, setUrlError] = useState("");
  const [projectType, setProjectType] = useState(props.projectType);
  const getBrowserOptions = (os) => {
    if (os === "MacOS") return ["Safari", "Firefox", "Chrome"];
    return ["Edge", "Firefox", "Chrome"]; // For Ubuntu & Windows
  };

  const filteredBrowserOptions = formData?.os
    ? getBrowserOptions(formData.os)
    : [];

  useEffect(() => {
    if (!filteredBrowserOptions.includes(formData?.browser)) {
      setFormData((prev) => ({ ...prev, browser: "" }));
    }
  }, [formData?.os]);

  const key = props.keywordDesign;

  const isValidURL = (url) => {
    if (!url) {
      return false;
    }

    // URL pattern validation for http/https with valid domain
    const urlPattern =
      /^https?:\/\/(?:[-\w.])+(?:\.[a-zA-Z]{2,})+(?:\/[^\s]*)?$/;

    if (!urlPattern.test(url)) {
      return false;
    }

    return true;
  };

  const isFormValid =
    (formData?.url || "").trim() !== "" &&
    isValidURL(formData.url) &&
    !!formData?.os &&
    !!formData?.browser;

  const location = useLocation();
  const defaultTestEnvironmentExpanded =
    key !== "" &&
    (location.state?.keywordDesignData ?? "") === "" &&
    !props.confirmed;

  const navigate = useNavigate();
  const setLoading = useContext(LoadingModalContext);
  const [showPassword, setShowPassword] = useState(false);

  const handleChange = (e) => {
  const { name, value } = e.target;

  if (name === "url") {
    if (value.trim() === "") {
      setUrlError(""); // No error for empty field
    } else if (!isValidURL(value)) {
      setUrlError("Please enter a valid URL (e.g., https://example.com)");
    } else {
      setUrlError(""); // Valid URL
    }
  }

  setFormData((prev) => ({
    ...prev,
    [name]: value,
  }));
};

  const handleSubmit = (e) => {
      props.setConfirmed(true);
      navigate(`/dashboard/test-automation/${props.framework}/${props.projectType}`, {
        state: { testenvironmentdata: formData, framework: props.framework, projectType: projectType },
      });
  };
  useEffect(() => {
    console.log(location.state, "testEnvironment79999999");
    setProjectType(location.state?.projectType || '');
    if (
      props.keywordDesignData &&
      Object.keys(props.keywordDesignData).length > 0
    ) {
      setFormData(props.keywordDesignData);
    }
  }, [props.keywordDesignData
    , location.state?.projectType
    , location.state?.framework
  ]);

  const buttonsgroup = [
    {
      label: "Confirm",
      variant: "contained",
      startIcon: <GenerateButton />,
      sx: { float: "right" },
      onClick: handleSubmit,
      disabled: !isFormValid,
    },
  ];

  return (
    <Box sx={{ maxWidth: 600, margin: "auto" }}>
      <CommonAccordion
        summary={"Test Environment"}
        details={
          <Box sx={{ display: "flex", flexDirection: "column", gap: 2, mt: 1 }}>
            <TextField
              label="Enter URL"
              name="url"
              value={formData?.url}
              onChange={handleChange}
              sx={{ width: "530px" }}
              variant="outlined"
              placeholder="https://mytestapp.com"
              autoComplete="off"
              error={!!urlError}
              helperText={urlError}
            />

            <Typography
              variant="body2"
              sx={{ color: "text.secondary", fontSize: "0.875rem" }}
            >
              Testing credentials for your web site to test functionality which
              requires user to login. (Username and password are optional)
            </Typography>

            <TextField
              label="Username"
              name="username"
              value={formData?.username}
              onChange={handleChange}
              sx={{ width: "530px" }}
              variant="outlined"
              placeholder="enter"
              autoComplete="new-username" // Prevent autofill
            />

            <TextField
              label="Password"
              name="password"
              type="text"
              value={formData?.password}
              onChange={handleChange}
              sx={{ width: "530px" }}
              variant="outlined"
              placeholder="enter"
              autoComplete="off"
              InputProps={{
                inputProps: showPassword
                  ? {}
                  : { style: { WebkitTextSecurity: "disc" } },
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton
                      onClick={() => setShowPassword((prev) => !prev)}
                      edge="end"
                    >
                      {showPassword ? <VisibilityOff /> : <Visibility />}
                    </IconButton>
                  </InputAdornment>
                ),
              }}
            />

            <TextField
              select
              label="OS"
              name="os"
              value={formData?.os}
              onChange={handleChange}
              sx={{ width: "530px" }}
              variant="outlined"
              placeholder="Select"
            >
              {osOptions.map((os) => (
                <MenuItem key={os} value={os}>
                  {os}
                </MenuItem>
              ))}
            </TextField>

            <TextField
              select
              label="Browser"
              name="browser"
              value={formData?.browser}
              onChange={handleChange}
              sx={{ width: "530px" }}
              variant="outlined"
              placeholder="Select"
            >
              {filteredBrowserOptions.map((browser) => (
                <MenuItem key={browser} value={browser}>
                  {browser}
                </MenuItem>
              ))}
            </TextField>

            <Box sx={{ mt: 1 }}></Box>
          </Box>
        }
        buttons={buttonsgroup}
        fullScreenMode={true}
        type={"output"}
        defaultExpanded={defaultTestEnvironmentExpanded}
      ></CommonAccordion>
    </Box>
  );
};


export default TestEnvironmentForm;
